module.exports = __webpack_public_path__ + "img/weddings_25_V.420caf0f.webp";